$(function () {
  // -----------------------------------------------------------
  // slick.js
  // -----------------------------------------------------------

  const $listItems = $(".sec-home-news__list");
  const $currentSlide = $(".sec-home-news-counter__current span");
  const $totalSlides = $(".sec-home-news-counter__total");

  $listItems.on(
    "init reInit beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      // Current slide number
      const slideNumber = (nextSlide !== undefined ? nextSlide : 0) + 1;
      $currentSlide.text(("0" + slideNumber).slice(-2));

      // Total slides
      const totalSlides = slick.slideCount;
      $totalSlides.text(("0" + totalSlides).slice(-2));
    }
  );

  $listItems.slick({
    autoplay: false,
    speed: 800,
    autoplaySpeed: 4000,
    variableWidth: true,
    infinite: true,
    dots: true,
    prevArrow: false,
    nextArrow: false,
    appendArrows: false,
    slidesToShow: 1,
  });
});
